import React, { useState } from "react";
import { Day } from "../../../../../../../Common/Function";
import EditComponent from "./EditCell";
import Form from "../Form";
import CardTime from "./Card";
import BoxShadow from "../../../../../../../Common/Components/BoxShadow";
const Week = ({ form, setForm, inputs, getTemplate }) => {
  if (form && form.weekTimes) {
    return (
      <BoxShadow style={{ margin: 0, padding: "10px", marginTop: "20px" }}>
        <div>
          <table class="table">
            <thead>
              <tr>
                <>
                  <th>#</th>
                  {Object.values(form.times.Friday).map((s, key) => {
                    return (
                      <>
                        <th
                          className="text-center"
                          key={key}
                        >{`${s.start} تا ${s.end} `}</th>
                      </>
                    );
                  })}
                </>
              </tr>
            </thead>
            <tbody>
              {form.keys &&
                form.keys.map(item => {
                  return (
                    <tr>
                      <td>{Day(item)}</td>
                      {form.times[item].map((s, key) => {
                        return (
                          <td className="text-center " key={key}>
                            <EditComponent
                              form={form}
                              setForm={setForm}
                              time={s}
                              day={item}
                              inputs={inputs}
                            />
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </BoxShadow>
    );
  }
  const deleteTime = _id => {
    setForm({
      ...form,
      times: form.times.filter(ele => ele._id !== _id),
    });
  };
  return (
    <>
      <BoxShadow style={{ margin: 0, padding: "10px", margin: "20px 0" }}>
        <Form form={form} setForm={setForm} inputs={inputs} />
      </BoxShadow>
      <div className="row">
        {form.times &&
          Array.isArray(form.times) &&
          form.times.map((time, count) => {
            return (
              <CardTime
                deleteItem={deleteTime}
                key={count}
                time={time}
                options={form.option}
              />
            );
          })}
      </div>
      <div className="row mt-2 justify-content-end">
        <div className="col-2 d-flex justify-content-end">
          <button className="btn btn-primary" onClick={getTemplate}>
            ساختن یک هفته{" "}
          </button>
        </div>
      </div>
    </>
  );
};
export default Week;
